/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type CaseDocumentAdmin = {
    readonly id?: number;
    readonly case_id?: number;
    readonly lab_order_id?: number;
    readonly case__accession?: string | null;
    /**
     * the category of document. E.g: 'Lab Requisition' or 'Doc Insurance'
     */
    category: CaseDocumentAdmin.category;
    name: string;
    /**
     * current status of the case document
     */
    status?: CaseDocumentAdmin.status;
    /**
     * If true, this document will get attached to the final case report.
     */
    attach_to_case_report?: boolean;
    readonly created_at?: string;
    readonly updated_at?: string;
}

export namespace CaseDocumentAdmin {

    /**
     * the category of document. E.g: 'Lab Requisition' or 'Doc Insurance'
     */
    export enum category {
        CASE_REPORT = 'Case-Report',
        UNMERGED_CASE_REPORT = 'Unmerged-Case-Report',
        PREVIOUS_PATHOLOGY_REPORT = 'Previous-Pathology-Report',
        PRELIMINARY_REPORT = 'Preliminary-Report',
        UNMERGED_PRELIMINARY_REPORT = 'Unmerged-Preliminary-Report',
        CLINIC_NOTES = 'Clinic-Notes',
        CONSENT_FORM = 'Consent-Form',
        CONSULTATION_REPORT = 'Consultation-Report',
        DOC_CLINICAL = 'Doc-Clinical',
        DOC_INSURANCE = 'Doc-Insurance',
        DIF_REPORT = 'DIF-Report',
        EXTRADEPARTMENTAL_REPORT = 'Extradepartmental-Report',
        FISH_REPORT = 'Fish-Report',
        GROSS_DIAGRAM = 'Gross-Diagram',
        LAB_REPORT = 'Lab-Report',
        LAB_REQUISITION = 'Lab-Requisition',
        SENDOUT_REQUISITION = 'Sendout-Requisition',
        MOLECULAR_REPORT = 'Molecular-Report',
        PATIENT_DEMOGRAPHICS = 'Patient-Demographics',
        REQUISITION_FORM = 'Requisition-Form',
        LOOSE_DOCUMENT = 'Loose-Document',
        MATERIAL_REQUEST = 'Material-Request',
        SELF_PAY_ATTESTATION = 'Self-Pay-Attestation',
        INTERNAL_DOCUMENT = 'Internal-Document',
        INDIGENT_PATIENT_AGREEMENT_NOTICE = 'Indigent-Patient-Agreement-Notice',
        IHC_REPORT = 'IHC-Report',
        CASE_CORRECTION_REQUEST = 'Case-Correction-Request',
        CONSULT_LETTER = 'Consult-Letter',
        TICK_REPORT = 'Tick-Report',
        CASTLE_REPORT = 'Castle-Report',
        ISH_REPORT = 'ISH-Report',
        GROSS_SPECIMEN_PHOTO = 'Gross-Specimen-Photo',
        OTHER = 'Other',
    }

    /**
     * current status of the case document
     */
    export enum status {
        PENDING = 'pending',
        UPLOADED = 'uploaded',
    }


}
